import React from "react";
import Container from "react-bootstrap/Container";

import MetaTitle from "./MetaTitle";
import Title from "./Title";
import Text from "./Text";
import CarouselCards from "./CarouselCards";

export default function ProfessionalCertificates({ data }) {
	const hashLink = "professionalCertificates";
	
	// Get section configuration from Contentful
	const sectionConfig = data?.fields?.jsonData?.sectionConfig || {};
	const certificatesData = data?.fields?.jsonData?.data || [];

	const config = {
		metaTitle: sectionConfig.metaTitle || "Professional Certificates",
		title: sectionConfig.title || "Get Certified",
		description: sectionConfig.description || "Explore our certification programs, led by experienced physician leaders, industry experts, and academic partners.",
		...sectionConfig
	};
	
	// Fallback to default certification data if no data is found
	const defaultCertificationsData = [
		{
			id: "ceo-academy",
			image: "/img/Fall 2024 Day 1 AM_65 1.jpg",
			badge: "OPEN ENROLLMENT",
			badgeType: "default",
			title: "CEO Academy Certification",
			description: "This 6-month program is designed to help you break through the 'glass ceiling' for physician executive selection and shorten the time from curiosity to readiness.",
			link: "/ceo-academy",
			buttonText: "LEARN MORE"
		},
		{
			id: "inter-professional",
			image: "/img/Fall 2024 Day 1 AM_54 1.jpg",
			badge: "OPEN ENROLLMENT",
			badgeType: "default",
			title: "Inter-Professional Leadership Academy Certification",
			description: "This comprehensive 6-month program is designed to elevate the capabilities of executive physician and nurse leader dyads for organizational impact.",
			link: "/inter-professional-leadership-academy",
			buttonText: "LEARN MORE"
		},
		{
			id: "cmo-academy",
			image: "/img/AAPL FriLate_11 1.jpg",
			badge: "OPEN ENROLLMENT",
			badgeType: "default",
			title: "CMO Academy Certification",
			description: "This 12-month program is designed to be the most comprehensive CMO educational program for aspiring and newly appointed VPMA/CMOs.",
			link: "/cmo-academy",
			buttonText: "LEARN MORE"
		},
		{
			id: "cpe-certification",
			image: "/img/Fall 2024 Day 1 AM_44 1.jpg",
			badge: "OPEN ENROLLMENT",
			badgeType: "default",
			title: "Certified Physician Executive Certification",
			description: "Complete the CPE curriculum where we've identified courses focused on management education. These are a combination of self-study, live online, and live in-person courses.",
			link: "/credentials/cpe",
			buttonText: "LEARN MORE"
		},
		{
			id: "leadership-fundamentals",
			image: "/img/Bookstore (1).jpg",
			badge: "OPEN ENROLLMENT",
			badgeType: "default",
			title: "Leadership Fundamentals Certificate",
			description: "Build foundational leadership skills with our comprehensive certificate program designed for emerging physician leaders.",
			link: "/certifications/leadership-fundamentals",
			buttonText: "LEARN MORE"
		}
	];
	
	const certificationsData = certificatesData.length > 0 ? certificatesData : defaultCertificationsData;

	return (
		<section id={hashLink} className="professional-certificates-section">
			<div className="inner-wrapper">
				<Container fluid className="px-4 px-md-5">
					{/* Header Section */}
					<div className="header-section text-start mb-2">
						<MetaTitle textAlign="start" text={config.metaTitle} marginBottom={1} />
						<Title
							className="w-100"
							textJustify="start"
							textAlign="start"
							element="h2"
							text={config.title}
							marginBottom={1}
						/>
						<Text
							text={config.description}
							textAlign="start"
							size="16"
							weight="100"
							textJustify="start"
							className="mb-0 text-muted"
						/>
					</div>

					<CarouselCards 
						items={certificationsData}
						hasImages={true}
						backgroundColor="#f8f9fa"
						cardImageHeight={250}
					/>
				</Container>
			</div>

			<style jsx="true">{`
				.professional-certificates-section {
					background: #f8f9fa;
					padding: 4rem 0;
					position: relative;
				}

				.inner-wrapper {
					background: #f8f9fa;
				}

				.header-section {
					margin-bottom: 4rem;
					position: relative;
				}

				/* Responsive Design */
				@media (max-width: 768px) {
					.header-section {
						margin-bottom: 3rem;
					}
					
					.professional-certificates-section {
						padding: 2rem 0;
					}
				}
			`}</style>
		</section>
	);
}